import { SupplyPartRenderer } from "@project/emerge";
import { useEffect, useRef } from "react";
import { type Group, Mesh } from "three";
import { getRawAluminumMaterial } from "../materials/AluminumMaterial";

interface SupplyPartRendererBlingProps {
  id: string;
}

// Diese Komponente stellt einen spezialisierten Renderer für Teile bereit
// Dabei wird das standardmäßige Aluminium-Material auf die Teile angewendet
export const SupplyPartRendererBling = ({
  id,
}: SupplyPartRendererBlingProps) => {
  const groupRef = useRef<Group>(null);

  // Durch die Verwendung des useAluminiumMaterial=true Parameters sorgt diese Komponente dafür,
  // dass der SupplyPartRenderer das Aluminium-Material anwendet
  useEffect(() => {
    // Warten, bis die Gruppe verfügbar ist
    if (!groupRef.current) return;

    // Aluminium-Material, das wir auf alle Meshes anwenden wollen
    const aluminumMaterial = getRawAluminumMaterial();

    // Funktion zum Durchsuchen aller Kinder in der Scene-Hierarchie
    // und Anwenden des Materials
    const applyMaterialToMeshes = () => {
      if (!groupRef.current) return;

      // Traversieren der Kinder und Suchen nach Meshes
      groupRef.current.traverse((child) => {
        if (child instanceof Mesh) {
          // Aluminum-Material auf Mesh anwenden
          child.material = aluminumMaterial;
        }
      });
    };

    // Dem Scene-Renderprozess erlauben, die Meshes zu laden,
    // bevor wir das Material anwenden
    const timer = setTimeout(() => {
      applyMaterialToMeshes();
    }, 100);

    // Aufräumen beim Unmount
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <group ref={groupRef}>
      <SupplyPartRenderer id={id} useAluminiumMaterial={true} />
    </group>
  );
};
